import { TdcStrings } from '@nuskin/ns-util'

const normalizeTdcKey = key => {
  return key.replace(/^(tdc_)?/, 'tdc_')
}

const constructQualificationsConfig = async () => {
  const locale = (new URLSearchParams(window.location.search)).get('locale') || 'en_US'
  const [language, market] = locale.split('_')

  let tdc = await TdcStrings.getStrings('exclusive-offer', language, market)
  tdc = Object.keys(tdc)
    .reduce((result, key) => {
      result[normalizeTdcKey(key)] = tdc[key]
      return result
    }, {})

  return {
    tdc: {
      ...tdc
    }
  }
}

let config = null
const loadConfig = async () => {
  config = await constructQualificationsConfig()
}

const getConfig = () => {
  return config
}

const getTdcString = (key) => {
  key = key.replace(/^(tdc_)?/, 'tdc_')
  return getTdc()[key] || ''
}

const getTdc = () => {
  return (config ||{}).tdc || {}
}

export default {
  loadConfig,
  getConfig,
  getTdcString,
  getTdc,
}

// todo should this have defaults?
